import React from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { _t } from "../../app/i18n/i18n";
import { NomuraLogo } from "./NomuraLogo";
import { Link } from "react-router-dom";
import { doChangePw } from "./api/doChangePw";
import { history } from "../../redux/configureStore";
import { getSid } from "lib/routing";

export const ChangePassword = ({ location }) => {
  if (!getSid()) history.push("/public/forgotten-password?err=invalid-token");
  const pwdRegex =
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[`~!@#$%^&*\\(\\)_\\-+=\\{\\}\\[\\]\\|\\:\\;'\\<\\>\\,\\.\\?\\/]).{10,128}$";
  return (
    <section className="w-100 screen-height text-white bg-dark p-5">
      <Form className="maxw-600" onSubmit={handleChangePassword}>
        <NomuraLogo />
        <p className="text-center font-weight-lighter h5">{_t("Reset Password")}</p>
        <Form.Control className="d-none" type="email" name="username" autoComplete="username" />

        <Form.Group>
          <Form.Label>{_t("New password")}</Form.Label>
          <Form.Control
            type="password"
            name="newPassword"
            autoComplete="new-password"
            placeholder={_t("New password")}
            className="more-border-radius"
            title={_t(
              "Between 10 and 128 characters comprising letters uppercase, lowercase, special character and numbers"
            )}
            pattern={pwdRegex}
            required
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>{_t("Retype new password")}</Form.Label>
          <Form.Control
            type="password"
            name="newPassword2"
            autoComplete="new-password"
            placeholder={_t("Retype new password")}
            className="more-border-radius"
            title={_t(
              "Between 10 and 128 characters comprising letters uppercase, lowercase, special character and numbers"
            )}
            pattern={pwdRegex}
            required
          />
        </Form.Group>

        {location.search.includes("retype-err") && <ErrorMsg title={_t("Please retype the same password.")} />}
        {location.search.includes("invalid-password") && (
          <ErrorMsg title={_t("Your new password must be different to the old password.")} />
        )}
        {location.search.includes("password-policy") && (
          <ErrorMsg
            title={_t(
              "Passwords must be between 10 and 128 characters in length, and must have all four classes of characters: Uppercase alphabet, lowercase alphabet, punctuation, and numbers."
            )}
          />
        )}
        {location.search.includes("weak-password") && (
          <ErrorMsg
            title={_t(
              "Sorry this password has been identified as a weak password even though it meets complexity criteria. \nPlease try again with a new password."
            )}
          />
        )}
        {location.search.includes("fail") && (
          <ErrorMsg title={_t("We were unable to update your password")} body={_t("Please request a new password")} />
        )}
        {location.search.includes("unexpected") && (
          <ErrorMsg
            title={_t("We were unable to update your password")}
            body={_t("A server error has occurred. Please wait a few moments, and try again.")}
          />
        )}

        <Button id="submit" variant="outline-light my-3" className="w-100 more-border-radius" type="submit">
          {_t("Reset Password")}
        </Button>

        <Button
          variant="outline-secondary mb-3"
          className="w-100 more-border-radius"
          onClick={() => window.history.back()}
        >
          {_t("Back")}
        </Button>

        <Link to="/public/login-support" className="w-100 text-white text-center d-block my-1">
          {_t("Need Support?")}
        </Link>
      </Form>
    </section>
  );
};

const handleChangePassword = (e) => {
  e.preventDefault();
  const form = e.target;
  const newPassword = form.newPassword.value;
  const newPassword2 = form.newPassword2.value;

  if (newPassword !== newPassword2) {
    history.push("/public/change-password?err=retype-err&sid=" + getSid());
  } else {
    doChangePw(newPassword);
  }
};

export const ErrorMsg = ({ title = "", body = "" }) => (
  <Alert variant="warning">
    <Alert.Heading>{title}</Alert.Heading>
    {body}
  </Alert>
);
